import { none, Option, some } from 'fp-ts/lib/Option'
import { Route } from 'vue-router'

import { log } from '@/log'
import { BrandRouteResolver } from '@/util/brandRouteResolver'

type ShopEntryTargetRoute = Pick<Route, 'params' | 'query'>

export class ShopEntryTargetResolver {
  public static resolveBrandEnglishName(route: ShopEntryTargetRoute): Option<string> {
    const brandFromPath = BrandRouteResolver.resolveBrandFromPathElement(
      route.params.brand_english_name || ''
    )

    if (brandFromPath) {
      return some(brandFromPath)
    }

    return this.resolveBrandEnglishNameFromScope(route.query.scope)
  }

  private static resolveBrandEnglishNameFromScope(
    scope: string | Array<string | null> | null | undefined
  ): Option<string> {
    /**
     * scopeクエリが複数指定され配列になっている場合には最初の要素を扱うことにする
     * この問題はプロダクト全体で見直しが必要かもしれない
     * https://github.com/Everforth/growthpalette-front/issues/8983
     */
    const scopeQuery = this.firstQueryValue(scope)
    if (!scopeQuery) {
      return none
    }

    const [kind, value] = scopeQuery.split('.')

    if (kind !== 'brand' || !value) {
      return none
    }

    return some(value)
  }

  private static firstQueryValue(value: string | Array<string | null> | null | undefined): string | null {
    if (typeof value === 'string') {
      return value
    }

    if (!Array.isArray(value)) {
      return null
    }

    log.warn(`[ShopEntryTargetResolver] scope query is unexpectedly an array:`, value)

    return value.find((item): item is string => typeof item === 'string') || null
  }
}
